import * as React from 'react';
import { MediaSurveys } from '../media-surveys';

// ValidationState.Pending = 1 — همان وضعیتی که شمارنده‌ی کنار منوی «اقدامات» می‌شمارد،
// پس عدد بج و تعداد ردیف‌های جدول هیچ‌وقت با هم اختلاف ندارند.
export const AuthMediasWaitingForAdmin = () => (
    <MediaSurveys
        lockedState={{ id: 1, title: 'در انتظار تایید' }}
        pageTitle="درخواست های احراز هویت در انتظار"
        cardTitle="درخواست های احراز هویت در انتظار"
    />
);
